import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <SEO title="Page Not Found | Mathura Homes" description="The page you are looking for could not be found." />
      <div className="text-center" data-testid="not-found-page">
        <p className="font-display text-8xl text-gold">404</p>
        <h1 className="font-display text-3xl text-navy mt-4">Page Not Found</h1>
        <p className="text-muted-foreground mt-3 max-w-md mx-auto">The page you're looking for doesn't exist or has been moved.</p>
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <Button asChild className="bg-gold text-navy hover:bg-gold-dark font-semibold"><Link to="/">Back to Home</Link></Button>
          <Button asChild variant="outline" className="border-navy text-navy hover:bg-navy hover:text-white"><Link to="/properties">Browse Properties</Link></Button>
        </div>
      </div>
    </div>
  );
}
